import type { EmergencyTimelineEntry } from '@src/models/interfaces/emergency.interface';
import { EmergencyTimelineMapper } from '@src/models/mappers/EmergencyTimelineMapper';
import { EmergencyTimelineRepository } from '@src/repositories/EmergencyTimelineRepository';

export class EmergencyTimelineService {
  private readonly repository: EmergencyTimelineRepository;

  constructor(repository = new EmergencyTimelineRepository()) {
    this.repository = repository;
  }

  async list(organizationId: string, incidentId: string): Promise<EmergencyTimelineEntry[]> {
    if (!organizationId || !incidentId) return [];
    const records = await this.repository.list(organizationId, incidentId);
    return records.map(EmergencyTimelineMapper.fromFirestore);
  }

  subscribe(
    organizationId: string,
    incidentId: string,
    onData: (entries: EmergencyTimelineEntry[]) => void,
    onError: (error: Error) => void,
  ): () => void {
    return this.repository.subscribe(
      organizationId,
      incidentId,
      records => onData(records.map(record => EmergencyTimelineMapper.fromFirestore(record))),
      onError,
    );
  }
}
